import React, { useEffect, useRef } from "react";
import FlowingWaves from "./FlowingWaves";

const COLORS = ["rgba(168,85,247,", "rgba(229,197,111,", "rgba(139,92,246,"];

const FuturisticFX = ({ waves = true }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let w, h, raf;

    const resize = () => {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * DPR;
      canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const particles = Array.from({ length: 40 }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 1.6 + 0.4,
      vx: (Math.random() - 0.5) * 0.12,
      vy: -(Math.random() * 0.18 + 0.04),
      a: Math.random() * 0.5 + 0.15,
      c: COLORS[Math.floor(Math.random() * COLORS.length)],
      tw: Math.random() * Math.PI * 2,
    }));

    let last = 0;
    let scrollIdleAt = 0;
    const onScroll = () => {
      scrollIdleAt = performance.now() + 150;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    const draw = (t) => {
      if (t < scrollIdleAt) {
        setTimeout(() => { raf = requestAnimationFrame(draw); }, 150);
        return;
      }
      raf = requestAnimationFrame(draw);
      if (t - last < 33) return; // ~30fps cap
      last = t;
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.x += p.vx;
        p.y += p.vy;
        p.tw += 0.02;
        if (p.y < -10) {
          p.y = h + 10;
          p.x = Math.random() * w;
        }
        if (p.x < -10) p.x = w + 10;
        if (p.x > w + 10) p.x = -10;
        const alpha = p.a * (0.6 + 0.4 * Math.sin(p.tw));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.c + alpha.toFixed(3) + ")";
        ctx.fill();
      }
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true" data-testid="futuristic-fx">
      {waves && <FlowingWaves intensity={2.4} />}
      <canvas ref={canvasRef} className="absolute inset-0" />
      <div className="scanlines absolute inset-0" />
      <div className="scan-beam" />
    </div>
  );
};

export default FuturisticFX;
